<template>
  <div class="details">
    <!-- <Header title="商品详情" background="#FBFBFB" /> -->
    <div class="content">
      <div class="content-block">
        <div class="my-swipe">
          <van-swipe
            class="my-swipe"
            indicator-color="white"
            :loop="false"
            :show-indicators="false"
          >
            <van-swipe-item
              v-for="(item, index) in info.album"
              :key="index"
              @click="showImage(index)"
            >
              <van-image :src="item" class="swipe-image" />
            </van-swipe-item>
            <van-swipe-item class="holder" v-if="!info.album.length">
              <span>暂无图片</span>
            </van-swipe-item>
          </van-swipe>
          <div class="flex-between">
            <img
              src="../../../assets/img/classify/back@2x.png"
              alt=""
              class="back-icon"
              @click="goBack()"
            />
            <span class="translation" @click="translation = !translation"
              >翻译</span
            >
          </div>
        </div>
        <div class="price-row">
          <p>
            <strong class="big-price">¥{{ info.marketPrice }}</strong>
            <span>({{ info.realPrice }}人民币)</span>
          </p>
          <p>
            <img src="../../../assets/img/classify/biaoqian@2x.png" alt="" />
            <span>汇率：{{ info.buyingRate }}</span>
          </p>
        </div>
        <h4 class="title" v-if="translation">{{ info.title }}</h4>
        <h4 class="title" v-else>{{ info.titleJp }}</h4>
        <p class="desc" v-if="translation">{{ info.subTitle }}</p>
        <p class="desc" v-else>{{ info.subTitleJp }}</p>
      </div>
      <div class="content-block">
        <h4 class="title-block">费用信息</h4>
        <div class="flex-between">
          <p v-if="shareUserId">分享人id: {{shareUserId}}</p>
        </div>
        <div class="flex-between">
          <p>当前汇率</p>
          <p>100日元={{ (info.buyingRate * 100).toFixed(3) }}人民币</p>
        </div>
        <div class="flex-between">
          <p>运费</p>
          <p class="main-color">{{ info.freight }}元人民币/{{ info.unit }}</p>
        </div>
        <div class="flex-between" v-if="false">
          <p>活动优惠</p>
          <p class="main-color">立减4人民币/单</p>
        </div>
        <div class="flex-between">
          <p>商品价格</p>
          <p>{{ info.marketPrice }}日元({{ info.realPrice }}人民币)</p>
        </div>
        <div class="flex-between">
          <p>商品总价(含手续费)</p>
          <p>{{ info.realPrice }}人民币</p>
        </div>
        <p class="remark">
          商品到达国内仓库称重后收取国际运费清关费用及国内运费。
        </p>
      </div>
      <div class="content-block">
        <h4 class="title-block">商品信息</h4>
        <div class="flex-between">
          <p>商品状态</p>
          <p v-if="translation">{{ goodDetails.sku }}</p>
          <p v-else>{{ goodDetails.skuJp }}</p>
        </div>
        <!-- 	<div class="flex-between">
					<p>商品状态</p>
					<p v-if="translation">{{goodDetails.condition}}</p>
					<p v-else>{{goodDetails.conditionJp}}</p>
				</div> -->
        <div class="flex-between">
          <p>邮费</p>
          <p v-if="translation">{{ goodDetails.condition }}</p>
          <p v-else>{{ goodDetails.conditionJp }}</p>
        </div>

        <div class="flex-between">
          <p>尺寸</p>
          <p v-if="translation">{{ goodDetails.brand }}</p>
          <p v-else>{{ goodDetails.brandJp }}</p>
        </div>
        <!-- <div class="flex-between">
					<p>出品者</p>
					<p>REI怜~.@Tokyo13967</p>
				</div>
				<div class="flex-between">
					<p>カテゴリー</p>
					<p>メンズ トップス Tシャツ/カットソー(半袖/袖なし)</p>
				</div>
				<div class="flex-between">
					<p>ブランド</p>
					<p>ポールスミス</p>
				</div>
				<div class="flex-between">
					<p>商品のサイズ</p>
					<p>FREESIZE</p>
				</div>
				<div class="flex-between">
					<p>商品の状態</p>
					<p>新品、未使用</p>
				</div>
				<div class="flex-between">
					<p>配送料の負担</p>
					<p>送料込み(出品者負担)</p>
				</div>
				<div class="flex-between">
					<p>配送の方法</p>
					<p>らくらくメルカリ便</p>
				</div>
				<div class="flex-between">
					<p>配送元地域</p>
					<p>東京都</p>
				</div>
				<div class="flex-between">
					<p>配送の方法</p>
					<p>発送日の目安</p>
				</div> -->
      </div>
    </div>
    <div class="content-block">
      <h4 class="title-block">商品介绍</h4>
      <div class="content-desc" v-html="info.detail" v-if="translation"></div>
      <div class="content-desc" v-html="info.detailJp" v-else></div>
    </div>
    <div
      class="content-block"
      v-if="goodDetails.sellerId"
      @click="goShopper(goodDetails.sellerId)"
    >
      <h4 class="title-block">卖家主页</h4>
      <div class="content-desc">{{ goodDetails.sellerName }}</div>
    </div>
    <!-- 底部栏 -->
    <div class="bottom-bar">
      <div class="icon-item" @click="like">
        <img
          src="../../../assets/img/classify/shoucangle.png"
          alt=""
          class="icon"
          v-if="other.isLiked"
        />
        <img
          src="../../../assets/img/classify/shoucang@2x.png"
          alt=""
          class="icon"
          v-else
        />
        <span>收藏</span>
      </div>
      <!-- <div class="icon-item">
				<img
				src="../../../assets/img/classify/buycar.png"
				alt=""
				class="icon"
				/>
				<span>购物车</span>
			</div> -->
      <!-- <div class="icon-item" @click="$router.push('/my/feedback/form')"> -->
      <div class="icon-item" @click="customer">
        <img
          src="../../../assets/img/classify/kefu@2x.png"
          alt=""
          class="icon"
        />
        <span>客服</span>
      </div>
      <div class="icon-item" @click="goHome">
        <img src="../../../assets/foot/home.png" alt="" class="icon" />
        <span>首页</span>
      </div>
      <!-- <div class="icon-item">
				<van-button v-clipboard:copy="url" v-clipboard:success="copySuccess" v-clipboard:error="copyError">分享</van-button>
			</div> -->
      <div class="icon-item"></div>
      <div class="right-button" v-if="info.canBuy == 1 && info.onOffer == 1">
        <template
          v-if="0 && !checktype(info.code)"
        >
          <span>麦卡里商品，请联系管理员手动下单</span>
        </template>
        <template
          v-else-if="info.buyFlag == 1"
        >
          <span>专用</span>
        </template>
        <template
          v-else-if="1 || info.buyFlag == 2"
        >
          <span>请联系管理员手动下单</span>
        </template>
        <template
          v-else-if="0 && info.buyFlag == 3"
        >
          <span>请联系人工竞价</span>
        </template>
        <template v-else-if="false">
          <div class="button-item" @click="addCar">加入购物车</div>
          <div class="button-item" @click="goBuy">立即购买</div>
        </template>
      </div>
      <div class="right-button" v-if="info.canBuy == 0">
        <span>暂未开通购买权限</span>
      </div>
      <div class="right-button" v-if="!info.canBuy || info.onOffer != 1">
        <template
          v-if="0 && info.buyFlag == 3"
        >
          <span>请联系人工竞价</span>
        </template>
        <span v-else-if="info.onOffer != 1">已售罄</span>
        <template
          v-else-if="info.buyFlag == 1"
        >
          <span>专用</span>
        </template>
      </div>
    </div>
    <div class="content-block">
      <h4 class="title-block">相似商品</h4>
      <div class="list">
        <div
          class="listItem"
          v-for="item in list"
          :key="item.id"
          @click="goDetails(item.id)"
        >
          <div class="itemCon">
            <img :src="item.thumbnails[0]" />
            <div class="price">¥{{ item.price }}</div>
            <img
              src="../../../assets/home/sold.png"
              class="sellOut"
              v-if="item.status == 'sold_out'"
            />
          </div>
        </div>
      </div>
      <van-popup v-model="show" position="bottom" class="buy-box">
        <div class="top-info-box">
          <van-image :src="info.thumb" alt="" class="thumb" />
          <div class="right-box">
            <p>
              <span>￥</span>
              <span class="price">{{ info.realPrice }}</span>
            </p>
          </div>
        </div>
        <div class="buy-box-content">
          <div class="flex-between">
            <span>购买数量</span>
            <van-stepper v-model="num" />
          </div>
        </div>
        <button class="go-buy" @click="goBuy">确定</button>
      </van-popup>
      <van-popup v-model="show2" position="bottom" class="tip-box">
        <div class="top-info-box">
          <h2>日本运费将由买家付款</h2>
        </div>
        <div class="right-button">
          <button class="button-item" @click="goBuy">确定</button>
          <button class="button-item" @click="show2 = false">取消</button>
        </div>
      </van-popup>
      <van-dialog class="customerDialog" v-model="isCustomer" title="客服">
        <img class="server" :src="customerInfo.wechatPic" />
        <p>{{ customerInfo.wechatCode }}</p>
      </van-dialog>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
import wx from "weixin-js-sdk";

import { ImagePreview } from "vant";
// import axios from 'axios'
export default {
  data() {
    return {
      id: "",
      status: "on_sale",
      goodDetails: {},
      info: {
        album: [],
        buyingRate: 1,
        permissions: false,
        titleJp: "",
        detailJp: "",
      },
      other: {
        isLiked: false,
      },
      translation: true,
      show: false,
      show2: false,
      num: 1,
      isCustomer: false,
      customerInfo: "",
      newId: "",
      list: [],
      url: "",
      nickname: '',
      userId: '',
      shareUserId: '',
    };
  },
  beforeRouteLeave(to, from, next) {
    // 设置下一个路由的 meta
    // from.meta.keepAlive = false; // 让 A 缓存，即不刷新
    // console.log(to)
    // console.log(from)
    next();
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  methods: {
    copySuccess() {
      this.$toast("复制成功");
    },
    copyError() {
      this.$toast("复制失败");
    },
    customer() {
      this.$post({
        url: "/portal",
        module: "Utils",
        interface: "6000",
      }).then((res) => {
        // this.$toast("添加至购物车");
        this.isCustomer = true;
        this.customerInfo = res;
      });
    },
    // 去购买
    goBuy() {
      this.show = false;
      if (this.show2 == false) {
        if (this.info.conditionJp == "着払い(購入者負担)") {
          this.show2 = true;
          return;
        }
      }
      let ids = [];
      ids[0] = this.newId * 1;
      let info = encodeURIComponent(JSON.stringify(ids));
      // console.log(ids,info,22)
      this.$router.push(`/classify/commodity/order?info=${info}&shareUserId=${this.shareUserId}`);
    },
    // 加入购物车
    addCar() {
      this.$post({
        url: "/portal/Shop",
        module: "Cart",
        interface: "2000",
        data: {
          goodsId: this.newId,
          num: 1,
        },
      }).then(() => {
        this.$toast("添加至购物车");
      });
    },
    checktype(code) {
      const regex = /^m\d{11,13}$/;
      const regex2 = /^\d*$/;
      return regex.test(code) || regex2.test(code);
    },
    // 收藏
    like() {
      this.$post({
        url: "/portal/Shop",
        module: "Goods",
        interface: this.other.isLiked ? "2101" : "2100", // 2101 取消 2100 关注
        data: {
          id: this.newId,
        },
      }).then(() => {
        this.$toast("成功");
        this.$func.sleep(300).then(this.getInfo);
      });
    },
    showImage(index) {
      ImagePreview({
        images: this.info.album,
        startPosition: index,
      });
    },
    // 查询详情
    getInfo() {
      this.$post({
        url: "/portal/Shop",
        module: "Goods",
        interface: "2000",
        data: {
          id: this.id,
        },
      }).then((res) => {
        console.log("商品详情", res);
        // goodDetails 用于商品信息 的 尺寸 商品状态
        this.goodDetails = res.goods;
        this.info = res.goods;
        this.newId = res.goods.id;
        this.other.isLiked = res.isLiked;
        this.userId = res.userId;
        this.nickname = res.nickname;
        // 请求获取最新数据（下订单时候才会用到）
        // axios.get('/goods/' + res.goods.code)
        this.getJssdkConfig();
      });
    },
    //获取相关商品
    getRelationInfo() {
      this.$post({
        url: "/portal/Shop",
        module: "Goods",
        interface: "2003",
        data: {
          id: this.id,
        },
      }).then((res) => {
        console.log("相关商品", res);
        this.list = res;
        console.log(this.list);
        // // goodDetails 用于商品信息 的 尺寸 商品状态
        // this.goodDetails = res.goods;
        // this.info = res.goods;
        // this.newId = res.goods.id
        // this.other.isLiked = res.isLiked;
        // // 请求获取最新数据（下订单时候才会用到）
        // // axios.get('/goods/' + res.goods.code)
      });
    },
    goShopper(sellerId) {
      this.$router.push({
        path: "/classify/commodity/shopper",
        query: {
          sellerId: sellerId,
        },
      });
    },
    goDetails(id) {
      this.$router.push({
        path: `/classify/commodity/details/${id}`,
      });
      this.id = id;
      // this.getInfo();
      // this.getRelationInfo();
    },
    goBack() {
      this.$router.back();
    },
    goHome() {
      this.$router.push({
        path: `/`,
      });
    },
    getJssdkConfig() {
      var _this = this;
      var url_list = window.location.href.split("#");
      var path0 = url_list[0];
      var path1 = url_list[1].split("?")[0];
      url_list = path0.split("?");
      var timestamp = new Date().valueOf();
      this.$post({
        url: "/portal/Wechat",
        module: "Index",
        interface: "1001",
        data: {
          pageUrl: path0,
        },
      }).then((res) => {
        console.log("1.0 jssdk", res);
        // res.debug = true;
        wx.config(res);
        // wx.error(function (res) {
        // 	console.log(res);
        // });
        wx.ready(function () {
          console.log(url_list[0] + "?time=" + timestamp + "&path=" + path1 + "\?shareUserId%3D" + _this.userId)
          //需在用户可能点击分享按钮前就先调用
          wx.updateAppMessageShareData({
            title: _this.nickname + "的分享", // 分享标题
            desc: _this.info.title, // 分享描述
            // link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            link: url_list[0] + "?time=" + timestamp + "&path=" + path1 + "\?shareUserId%3D" + _this.userId,
            imgUrl: "https:" + _this.info.thumb, // 分享图标
            success: function () {
              console.log("success");
            },
            fail: function () {
              console.log("fail");
            },
          });
        });
      });
    },
  },
  components: {},
  urlName: "id",
  created() {
    this.id = this.$route.params.id;
    this.shareUserId = this.$route.query.shareUserId;
    this.getInfo();
    this.getRelationInfo();
    this.url = window.location.href;
    if (this.$route.params.status != undefined) {
      this.status = this.$route.params.status;
    }
    console.log("status", this.status);
  },
  updated() {
    console.log("updated", this.id);
  },
  watch: {
    $route(nVal) {
      console.log(nVal);
      this.id = this.$route.params.id;
      if (this.$route.params.status != undefined) {
        this.status = this.$route.params.status;
      }
      this.getInfo();
      this.getRelationInfo();
      document.getElementsByClassName("details")[0].scrollTop = 0;
    },
  },
};
</script>

<style scoped lang="less">
.customerDialog {
  text-align: center;

  .server {
    height: 300px;
    width: 300px;
  }
}

.buy-box {
  height: 40%;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 10px;
  display: flex;
  flex-direction: column;

  .top-info-box {
    display: flex;

    .thumb {
      width: 100px;
      height: 100px;
      border-radius: 6px;
    }

    .right-box {
      height: 100%;
      padding-left: 10px;
      font-size: 14px;

      .price {
        color: #fd0212;
        font-size: 18px;
        font-weight: bold;
      }
    }
  }

  .go-buy {
    width: 100%;
    padding: 10px;
    border-style: none;
    outline: none;
    border-radius: 18px;
    background-color: #fd0212;
    color: white;
  }

  .buy-box-content {
    flex: 1;
    padding: 10px;

    .sku-item {
      font-size: 14px;
      color: #666;
    }
  }
}

.tip-box {
  height: 15%;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 10px;
  display: flex;
  flex-direction: column;

  .go-buy {
    width: 49%;
    padding: 10px;
    border-style: none;
    outline: none;
    border-radius: 18px;
    background-color: #02fd7b;
    color: white;
  }

  .go-buy2 {
    width: 49%;
    padding: 10px;
    border-style: none;
    outline: none;
    border-radius: 18px;
    background-color: #fd0212;
    color: white;
  }

  .right-button {
    flex: 1;
    display: flex;
    margin-left: 13px;
    height: 36px;
    border-radius: 100px;
    overflow: hidden;
    margin-right: 16px;
    background-color: #dee1e6;
    font-size: 14px;
    color: #919398;
    line-height: 36px;
    justify-content: center;
    text-align: center;

    .button-item {
      flex: 1;
      height: 100%;
      color: #ffffff;
      position: relative;
      border: none;

      &::after {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
      }

      &:active::after {
        content: "";
      }

      &:first-child {
        background-color: #ffc107;
      }

      &:last-child {
        background-color: #fd0212;
      }
    }
  }
}

.details {
  height: 100vh;
  overflow: auto;
  background: #fbfbfb;
  font-family: PingFangSC-Regular, PingFang SC;

  .bottom-bar {
    position: sticky;
    bottom: 0;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
    border-radius: 40px 40px 0px 0px;
    display: flex;
    align-items: center;
    overflow: hidden;
    height: 50px;

    .icon-item {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      font-size: 12px;
      color: #101010;
      margin-left: 16px;

      .icon {
        width: 22px;
        height: 22px;
      }
    }

    .right-button {
      flex: 1;
      display: flex;
      margin-left: 13px;
      height: 36px;
      border-radius: 100px;
      overflow: hidden;
      margin-right: 16px;
      background-color: #dee1e6;
      font-size: 14px;
      color: #919398;
      line-height: 36px;
      justify-content: center;
      text-align: center;

      .button-item {
        flex: 1;
        height: 100%;
        color: #ffffff;
        position: relative;

        &::after {
          position: absolute;
          display: block;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.1);
        }

        &:active::after {
          content: "";
        }

        &:first-child {
          background-color: #ffc107;
        }

        &:last-child {
          background-color: #fd0212;
        }
      }
    }
  }

  .content-block {
    background: #ffffff;
    box-shadow: 0px 6px 20px 0px rgba(16, 16, 16, 0.04);
    border-radius: 40px;
    overflow: hidden;
    padding: 14px 16px 28px;
    margin-bottom: 16px;
    position: relative;

    &:first-child {
      border-top-right-radius: 0;
      border-top-left-radius: 0;
    }

    & > .flex-between {
      margin-top: 16px;
      font-size: 13px;

      p {
        max-width: 50%;

        &:first-child {
          color: #414245;
          text-align: left;
        }

        &:last-child {
          color: #101010;
          text-align: right;

          &.main-color {
            color: #9d28b0;
          }
        }
      }
    }

    & > .title {
      font-size: 18px;
      color: #101010;
      margin-bottom: 14px;
    }

    & > .desc {
      font-size: 14px;
      color: #919398;
    }

    & > .title-block {
      font-size: 16px;
      color: #303133;
      padding-bottom: 11px;

      &::after {
        content: "";
        position: absolute;
        top: 51px;
        left: 0;
        width: 100%;
        display: block;
        height: 2px;
        background: linear-gradient(90deg, #fd0212 0%, #ffffff 100%);
        opacity: 0.3;
      }
    }

    & > .remark {
      font-size: 14px;
      color: #0091ff;
      margin-top: 15px;
    }

    & > .content-desc {
      font-size: 13px;
      color: #414245;
      margin-top: 14px;
    }

    & > .my-swipe {
      height: 273px;
      position: relative;

      & > .my-swipe {
        height: 100%;
      }

      .flex-between {
        position: absolute;
        top: 0;
        width: 100%;
        padding: 10px;

        .back-icon {
          width: 24px;
          height: 24px;
        }

        .translation {
          padding: 3px 7px;
          background: #101010;
          border-radius: 12px;
          font-size: 12px;
          color: #ffffff;
          opacity: 0.5;
        }
      }

      .swipe-image {
        width: 100%;
        height: 100%;
        object-fit: cover;

        /deep/.van-icon {
          font-size: 44px;
        }
      }

      .van-swipe-item.holder {
        background-color: #f7f7f7;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        color: #808080;
        font-size: 14px;
      }
    }

    & > .price-row {
      margin: 16px 0 17px;
      display: flex;
      justify-content: space-between;

      p:first-child {
        color: #fd0212;

        strong {
          font-size: 18px;
        }

        span {
          font-size: 14px;
          font-weight: 600;
        }
      }

      p:last-child {
        display: flex;
        align-items: center;

        img {
          width: 14px;
          height: 18px;
        }

        span {
          background: #fd0212;
          border-radius: 2px;
          font-size: 12px;
          color: white;
          height: 18px;
          line-height: 18px;
          padding: 0 4px 0 2px;
        }
      }
    }

    .list {
      width: 100%;
      padding: 0 16px;
      box-sizing: border-box;
      display: flex;
      padding-top: 16px;
      flex-wrap: wrap;

      .listItem {
        width: 33.33%;
        height: 108px;
        padding: 5px;

        .itemCon {
          width: 100%;
          height: 100%;
          position: relative;
          background: #f5f7f6;
          box-shadow: 0px 2px 4px 0px rgba(16, 16, 16, 0.1);
          border-radius: 8px;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }

          .price {
            width: 48px;
            height: 20px;
            background: #101010;
            border-radius: 0px 8px 8px 8px;
            opacity: 0.6;
            color: #ffffff;
            font-size: 13px;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: 0;
            bottom: 0;
          }
          .sellOut {
            height: 44px;
            width: 44px;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
  }
}
</style>
